import {
    AppEnumHelper,
    dateCompare,
    DetailItem,
    DetailSection,
    DOMAIN_TYPES,
    TaskEnums,
} from "@/Shared";
import { TaskModel } from '../TaskModel';
import { AuditViewModel } from "@/Shared/Logic/ViewModels/AuditViewModel";
import { AuditModel } from "@/Shared/Logic/Models/AuditModel";
import { AccessRightModel } from "@/Domains/Auth";


export interface TaskVMParams {
    task: TaskModel;
    viewEnums: TaskEnums;
    accessRight: AccessRightModel;
    isDisplaying: boolean;
}

export class TaskViewModel {

    public id: number;
    public model: TaskModel;
    public category: string;
    public label!: string;
    public audit!: AuditViewModel;
    public creationDate!: string;
    public creatorName!: string;
    public isDeleted!: boolean;
    public cardClass!: string;

    public constructor(private params: TaskVMParams) {
        const { task, viewEnums, isDisplaying } = this.params;

        this.model = task;
        this.id = task?.id ?? 0;
        this.audit = new AuditViewModel(task as AuditModel);
        this.creationDate = this.audit.creationDate;
        this.creatorName = this.audit.creatorName;

        this.category = AppEnumHelper.getByValue(viewEnums.TaskCategoryEnum, task?.category)?.label ?? "";

        this.label = task.label;
        this.isDeleted = !!task?.deletedAt
        this.cardClass = isDisplaying ? 'active' : '';
    }

    get title() {
        return "Tâche N° " + this.id + " - " + this.category.toUpperCase();
    }

    getAllSections = (): DetailSection[] => {
        const sections: DetailSection[] = [
            {
                sectionFn: this.getTaskSection,
                legend: 'Caractéristiques Générales',
                type: 'box'
            },
        ];

        if (this.params.accessRight.canAudit(DOMAIN_TYPES.Task)) {
            sections.push({
                sectionFn: this.audit.getAuditTrail,
                legend: 'Traçabilité',
                type: 'box'
            });
        }
        return sections;
    }

    getTaskSection = () => {
        return [
            { label: "N° Tâche", value: this.id },
            { label: "Catégorie", value: this.category },
            { label: "Titre", value: this.label },
            { label: "Créée le", value: this.creationDate },
        ] as DetailItem[];
    }

    compareTo(other: TaskViewModel): number {
        return dateCompare(this.model.createdAt ?? "", other.model.createdAt ?? "");
    }
}